import { makeAutoObservable } from "mobx";
import React from "react";
import { Button, Space, Tooltip } from "antd";
import { blue, green, yellowPrimary } from "../color";
import { BankOutlined, TeamOutlined, UserOutlined } from "@ant-design/icons";

class SelectUserStore {
  // Selected Modal Data (k dùng nữa)

  selectedListData = undefined;

  setSelectedListData = (dataObj) => {
    this.selectedListData = dataObj;
  };

  // refactor data select    //
  // ====================== //

  selectData = {
    handler: [],
    combiner: [],
    follower: [],
    leader: [],
  };

  setSelectData = (dataObj) => {
    this.selectData = dataObj;
  };

  clearSelectData = () => {
    this.selectData = {
      handler: [],
      combiner: [],
      follower: [],
      leader: [],
    };
  };

  tableUserType = undefined;

  setTableUserType = (type) => {
    this.tableUserType = type;
  };

  tableDepartmentType = undefined;

  setTableDepartmentType = (type) => {
    this.tableDepartmentType = type;
  };

  tableGroupType = undefined;

  setTableGroupType = (type) => {
    this.tableGroupType = type;
  };

  convertListToDefault = (originList) =>
    originList.map((el) => ({
      full_name: el.name_uppercase ? el.name_uppercase : "",
      id: el.assignee_code,
      assignee_type: el.assignee_type,
      permission: el.permission,
      last_date_read: el.last_date_read,
    }));

  // data ẩn - hiện - type - Modal select
  // User

  isVisibleModalSelectUser = false;
  typeModalSelectUser = undefined;

  setIsVisibleModalSelectUser = (boolean) => {
    this.isVisibleModalSelectUser = boolean;
  };

  setTypeModalSelectUser = (type) => {
    this.typeModalSelectUser = type;
  };

  // Department

  isVisibleModalSelectDepartment = false;
  typeModalSelectDepartment = undefined;

  setIsVisibleModalSelectDepartment = (boolean) => {
    this.isVisibleModalSelectDepartment = boolean;
  };

  setTypeModalSelectDepartment = (type) => {
    this.typeModalSelectDepartment = type;
  };

  // Group
  isVisibleModalSelectGroup = false;
  typeModalSelectGroup = undefined;

  setIsVisibleModalSelectGroup = (boolean) => {
    this.isVisibleModalSelectGroup = boolean;
  };

  setTypeModalSelectGroup = (type) => {
    this.typeModalSelectGroup = type;
  };

  // Clear data ẩn - hiện - type - Modal select

  clearTypeModalSelect = () => {
    this.isVisibleModalSelectUser = false;
    this.typeModalSelectUser = undefined;
    this.isVisibleModalSelectDepartment = false;
    this.typeModalSelectDepartment = undefined;
    this.isVisibleModalSelectGroup = false;
    this.typeModalSelectGroup = undefined;
  };

  /** Handle Close Modal Select User */
  handleCloseModalSelectUser = () => {
    this.isVisibleModalSelectUser = false;
    this.selectData = {
      ...this.selectData,
      [this.typeModalSelectUser]: [],
    };
  };

  handleCloseModalSelectDepartment = () => {
    this.isVisibleModalSelectDepartment = false;
    this.selectData = {
      ...this.selectData,
      [this.typeModalSelectDepartment]: [],
    };
  };

  handleCloseModalSelectGroup = () => {
    this.isVisibleModalSelectGroup = false;
    this.selectData = {
      ...this.selectData,
      [this.typeModalSelectGroup]: [],
    };
  };

  userButtonSelect = (type) => {
    return (
      <Space>
        <Tooltip title={"Chọn người dùng"} color={blue}>
          <Button
            icon={<UserOutlined style={{ color: blue }} />}
            onClick={() => {
              this.isVisibleModalSelectUser = true;
              this.typeModalSelectUser = type;
            }}
          />
        </Tooltip>
      </Space>
    );
  };

  groupButtonSelect = (type) => {
    return (
      <Space>
        <Tooltip title="Chọn người dùng" color={blue}>
          <Button
            icon={<UserOutlined style={{ color: blue }} />}
            onClick={() => {
              this.isVisibleModalSelectUser = true;
              this.typeModalSelectUser = type;
            }}
          />
        </Tooltip>
        <Tooltip title="Chọn nhóm" color={"#ffc069"}>
          <Button
            icon={<TeamOutlined />}
            style={{ color: yellowPrimary }}
            onClick={() => {
              this.isVisibleModalSelectGroup = true;
              this.typeModalSelectGroup = type;
            }}
          />
        </Tooltip>
        <Tooltip title="Chọn phòng ban" color={"#10ac84"}>
          <Button
            icon={<BankOutlined />}
            style={{ color: green }}
            onClick={() => {
              this.isVisibleModalSelectDepartment = true;
              this.typeModalSelectDepartment = type;
            }}
          />
        </Tooltip>
      </Space>
    );
  };
}

const selectUserStore = new SelectUserStore();
export default selectUserStore;
